"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutlineDestination = exports.NoFillDestination = exports.SolidFillDestination = exports.WordProcessingShapePropertiesDestination = void 0;
var tslib_1 = require("tslib");
var map_creator_1 = require("../../../../base-utils/map-creator");
var color_1 = require("../../../../core/model/color/color");
var drawing_color_1 = require("../../../../core/model/drawing/drawing-color");
var drawing_color_model_info_1 = require("../../../../core/model/drawing/drawing-color-model-info");
var unit_converter_1 = require("@devexpress/utils/lib/class/unit-converter");
var destination_1 = require("../destination");
var hex_rgbcolor_destination_1 = require("../themes/color/hex-rgbcolor-destination");
var preset_color_destination_1 = require("../themes/color/preset-color-destination");
var scheme_color_destination_1 = require("../themes/color/scheme-color-destination");
var drawing_destination_1 = require("./drawing-destination");
var alpha_color_transform_1 = require("../../../../core/model/drawing/transform/alpha-color-transform");
var common_1 = require("@devexpress/utils/lib/utils/common");
var dx_color_1 = require("../../../../core/model/color/dx-color");
var WordProcessingShapePropertiesDestination = (function (_super) {
    tslib_1.__extends(WordProcessingShapePropertiesDestination, _super);
    function WordProcessingShapePropertiesDestination(data, shape, size) {
        var _this = _super.call(this, data) || this;
        _this.shape = shape;
        _this.size = size;
        _this.fillColor = new drawing_color_1.DrawingColor(drawing_color_model_info_1.DrawingColorModelInfo.empty);
        return _this;
    }
    Object.defineProperty(WordProcessingShapePropertiesDestination.prototype, "elementHandlerTable", {
        get: function () {
            return WordProcessingShapePropertiesDestination.handlerTable;
        },
        enumerable: false,
        configurable: true
    });
    WordProcessingShapePropertiesDestination.getThis = function (data) {
        return data.destinationStack.getThis();
    };
    WordProcessingShapePropertiesDestination.onSolidFill = function (data, _reader) {
        return new SolidFillDestination(data, WordProcessingShapePropertiesDestination.getThis(data).fillColor);
    };
    WordProcessingShapePropertiesDestination.onNoFill = function (data, _reader) {
        return new NoFillDestination(data, WordProcessingShapePropertiesDestination.getThis(data).fillColor);
    };
    WordProcessingShapePropertiesDestination.onOutline = function (data, _reader) {
        return new OutlineDestination(data, WordProcessingShapePropertiesDestination.getThis(data).shape);
    };
    WordProcessingShapePropertiesDestination.onGraphicFrame = function (data, _reader) {
        return new drawing_destination_1.GraphicFrameDestination(data, WordProcessingShapePropertiesDestination.getThis(data).size);
    };
    WordProcessingShapePropertiesDestination.prototype.processElementClose = function (_reader) {
        var alphaTransform = this.getAlphaTransform();
        var color = this.fillColor.color.toRgb(this.data.documentModel.colorProvider);
        if (common_1.isDefined(alphaTransform))
            color = dx_color_1.DXColor.fromArgb(alphaTransform.value, color);
        this.shape.fillColor = color;
    };
    WordProcessingShapePropertiesDestination.prototype.getAlphaTransform = function () {
        for (var _i = 0, _a = this.fillColor.transforms.transforms; _i < _a.length; _i++) {
            var transform = _a[_i];
            if (transform instanceof alpha_color_transform_1.AlphaColorTransform)
                return transform;
        }
        return null;
    };
    WordProcessingShapePropertiesDestination.handlerTable = new map_creator_1.MapCreator()
        .add('solidFill', WordProcessingShapePropertiesDestination.onSolidFill)
        .add('noFill', WordProcessingShapePropertiesDestination.onNoFill)
        .add('ln', WordProcessingShapePropertiesDestination.onOutline)
        .add('xfrm', WordProcessingShapePropertiesDestination.onGraphicFrame)
        .get();
    return WordProcessingShapePropertiesDestination;
}(destination_1.ElementDestination));
exports.WordProcessingShapePropertiesDestination = WordProcessingShapePropertiesDestination;
var SolidFillDestination = (function (_super) {
    tslib_1.__extends(SolidFillDestination, _super);
    function SolidFillDestination(data, color) {
        var _this = _super.call(this, data) || this;
        _this.color = color;
        return _this;
    }
    Object.defineProperty(SolidFillDestination.prototype, "elementHandlerTable", {
        get: function () {
            return SolidFillDestination.handlerTable;
        },
        enumerable: false,
        configurable: true
    });
    SolidFillDestination.getThis = function (data) {
        return data.destinationStack.getThis();
    };
    SolidFillDestination.onSRgbColor = function (data, _reader) {
        return new hex_rgbcolor_destination_1.HexRGBColorDestination(data, SolidFillDestination.getThis(data).color);
    };
    SolidFillDestination.onSchemeColor = function (data, _reader) {
        return new scheme_color_destination_1.SchemeColorDestination(data, SolidFillDestination.getThis(data).color);
    };
    SolidFillDestination.onPresetColor = function (data, _reader) {
        return new preset_color_destination_1.PresetColorDestination(data, SolidFillDestination.getThis(data).color);
    };
    SolidFillDestination.handlerTable = new map_creator_1.MapCreator()
        .add('srgbClr', SolidFillDestination.onSRgbColor)
        .add('schemeClr', SolidFillDestination.onSchemeColor)
        .add('prstClr', SolidFillDestination.onPresetColor)
        .get();
    return SolidFillDestination;
}(destination_1.ElementDestination));
exports.SolidFillDestination = SolidFillDestination;
var NoFillDestination = (function (_super) {
    tslib_1.__extends(NoFillDestination, _super);
    function NoFillDestination(data, color) {
        var _this = _super.call(this, data) || this;
        _this.color = color;
        return _this;
    }
    NoFillDestination.prototype.processElementOpen = function (_reader) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.color.rgb = color_1.ColorHelper.NO_COLOR;
                return [2];
            });
        });
    };
    return NoFillDestination;
}(destination_1.LeafElementDestination));
exports.NoFillDestination = NoFillDestination;
var OutlineDestination = (function (_super) {
    tslib_1.__extends(OutlineDestination, _super);
    function OutlineDestination(data, shape) {
        var _this = _super.call(this, data) || this;
        _this.shape = shape;
        _this.color = new drawing_color_1.DrawingColor(new drawing_color_model_info_1.DrawingColorModelInfo());
        return _this;
    }
    Object.defineProperty(OutlineDestination.prototype, "elementHandlerTable", {
        get: function () {
            return OutlineDestination.handlerTable;
        },
        enumerable: false,
        configurable: true
    });
    OutlineDestination.getThis = function (data) {
        return data.destinationStack.getThis();
    };
    OutlineDestination.onSolidFill = function (data, _reader) {
        return new SolidFillDestination(data, OutlineDestination.getThis(data).color);
    };
    OutlineDestination.onNoFill = function (data, _reader) {
        return new NoFillDestination(data, OutlineDestination.getThis(data).color);
    };
    OutlineDestination.prototype.processElementClose = function (_reader) {
        this.shape.outlineColor = this.color.color.toRgb(this.data.documentModel.colorProvider);
    };
    OutlineDestination.prototype.processElementOpen = function (reader) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var value;
            return tslib_1.__generator(this, function (_a) {
                value = this.data.readerHelper.getIntegerValue(reader, 'w', Number.MIN_VALUE);
                if (value != Number.MIN_VALUE)
                    this.shape.outlineWidth = unit_converter_1.UnitConverter.emuToTwips(value);
                return [2];
            });
        });
    };
    OutlineDestination.handlerTable = new map_creator_1.MapCreator()
        .add('solidFill', OutlineDestination.onSolidFill)
        .add('noFill', OutlineDestination.onNoFill)
        .get();
    return OutlineDestination;
}(destination_1.ElementDestination));
exports.OutlineDestination = OutlineDestination;
